import Header from '@/shared/components/Header';
import Sidebar from '@/shared/components/Sidebar';
import { useInactivityTimeout } from '@/shared/hooks';
import { useAccessControl } from '@skewb/access-control/react';
import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { Outlet } from 'react-router';

export default function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { isLoading: isLoadingAbility } = useAccessControl();
  useInactivityTimeout();

  if (isLoadingAbility) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div role="status" className="text-center space-y-4">
          <Loader2 className="size-8 animate-spin text-primary mx-auto" />
          <p className="text-sm text-muted-foreground">Loading your workspace…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background theme-transition">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <div
        className={`${sidebarCollapsed ? 'ml-16' : 'ml-64'} transition-all duration-300 print:ml-0`}
      >
        <Header />
        <main className="h-[calc(100vh-4rem)] overflow-auto bg-background theme-transition p-6 print:h-auto print:overflow-visible">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
